@for (tick of ticks(); track tick.id) {
  <div class="tick border-secondary">
    @if (tick.mark !== null) {
      <div class="small text-tertiary">{{ tick.mark }}</div>
    }
  </div>
}
